import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { User } from 'src/app/models/user.model';

export interface TaskHistoryNavigation {
  searchParams: {
    assigned: boolean;
    completed: boolean;
    startDate: Date;
    endDate: Date;
    sortByField: string;
    sortDirection: string;
  };
  currentPage: number;
  taskOwner: User;
  taskByState: { label: string; value: boolean };
  dateFilter: { label: string; startDate: Date; endDate: Date };
  showMyAssignedTasks: boolean;
  assignedView: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class TaskHistoryNavigationService {
  readonly currentTaskHistoryNavObs$: Observable<TaskHistoryNavigation>;
  private currentTaskHistoryNavSubject: BehaviorSubject<TaskHistoryNavigation> = new BehaviorSubject(null);

  constructor() {
    this.currentTaskHistoryNavObs$ = this.currentTaskHistoryNavSubject.asObservable();
  }

  public setCurrentTaskHistoryNav(navigation: TaskHistoryNavigation): void {
    this.currentTaskHistoryNavSubject.next(navigation);
  }
}
